import React from 'react';
import logo from "../../../assets/لوگو 4.svg";
import {FaBars} from "react-icons/fa"
import { adminContext } from '../../../context/admincontext';
import { useContext } from 'react';
const Header = () => {
    const {toggel,setToggel ,page } = useContext(adminContext)

    return (
        <div className='userpanel-header'>
        <div>
        <h5 className='me-3' style={{fontWeight:900}}>ادمین</h5>
        </div>
        <strong>{page}</strong>
        <button className='btn' onClick={()=> {setToggel(!toggel)}}>
        <FaBars/>
        </button>

        </div>
    );
};

export default Header;